import Comparision from 'components/Comparision';
import {PriceFAQ} from 'components/FAQ';
import Layout from 'components/Layout';
import Price from 'components/Price';
import SEO from 'components/seo';
import React from 'react';
import classNames from 'classnames';
import Style from 'styles/components/price.module.scss';
import priceTopView from 'images/price/topView.png';

const TopView = () => {
  return (
    <section className={Style.price}>
      <div className={Style.price__topView}>
        <div className={Style.price__topView__label}>
          売れるまでずっと無料<br />
          気軽にネット販売を始められる
        </div>
        <img className = {classNames(Style.price__topView__img)} src={priceTopView} alt=""/>
      </div>
    </section>
  );
}

const PricePage = () => {
  return (
    <Layout>
      <SEO title='comachicart' path='price' />
      <TopView />
      <Price visibleVoice={true} />
      <Comparision />
      <PriceFAQ />
    </Layout>
  );
};

export default PricePage;
